export default __webpack_public_path__ + "static/media/210-result-1.a5c123ba.svg";